/* istanbul ignore file */

export const mmWidgetInit = () => {
  window.zESettings = {
    webWidget: {
      chat: {
        departments: {
          enabled: [],
        },
      },
    },
  };
};
